import {
  Box,
  Button,
  Input,
  Select,
  FormControl,
  FormLabel,
  SimpleGrid,
  Flex,
  Checkbox,
  Text,
} from '@chakra-ui/react';

export default function SearchBar({
  searchFields,
  searchParams,
  setSearchParams,
  onSearch,
}) {
  const handleInputChange = (field, value) => {
    setSearchParams({
      ...searchParams,
      [field]: value,
    });
  };

  const handleSearch = () => {
    onSearch();
  };

  return (
    <Box
      width="100%"
      p={4}
      borderRadius="md"
      boxShadow="md"
      backgroundColor="white"
      mb={4}
    >
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        {searchFields.map((field, i) => (
          field.type !== 'checkboxes' && (
            <FormControl key={i}>
              <FormLabel fontSize="sm" color="gray.600">
                {field.label}
              </FormLabel>
              {field.type === 'text' && (
                <Input
                  placeholder={`${field.label}で検索`}
                  onChange={(e) => handleInputChange(field.name, e.target.value)}
                  value={searchParams[field.name] || ''}
                  width="100%"
                />
              )}
              {field.type === 'dropdown' && (
                <Select
                  placeholder="選択してください"
                  onChange={(e) => handleInputChange(field.name, e.target.value)}
                  value={searchParams[field.name] || ''}
                  width="100%"
                >
                  {field.options.map((option) => (
                    <option key={option.key} value={option.key}>
                      {option.value}
                    </option>
                  ))}
                </Select>
              )}
              {field.type === 'date' && (
                <Input
                  type="date"
                  onChange={(e) => handleInputChange(field.name, e.target.value)}
                  value={searchParams[field.name] || ''}
                  width="100%"
                />
              )}
            </FormControl>
          )
        ))}
      </SimpleGrid>

      {/* 技術スキル checkboxes */}
      {searchFields
        .filter((field) => field.type === 'checkboxes')
        .map((field) => (
          <Box key={field.name} mb={4}>
            <Text fontSize="sm" color="gray.600" mb={2}>
              {field.label}
            </Text>
            <Flex wrap="wrap" gap={3}>
              {field.options.map((option) => (
                <Checkbox
                  key={option.key}
                  value={option.key}
                  isChecked={(searchParams[field.name] || []).includes(option.key)}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    let selected = searchParams[field.name] || [];
                    if (e.target.checked) {
                      selected = [...selected, value];
                    } else {
                      selected = selected.filter((v) => v !== value);
                    }
                    setSearchParams({
                      ...searchParams,
                      [field.name]: selected,
                    });
                  }}
                >
                  {option.value}
                </Checkbox>
              ))}
            </Flex>
          </Box>
      ))}


      {/* Search button aligned right */}
      <Flex justify="flex-start">
        <Button colorScheme="gray" onClick={handleSearch}>
          検索
        </Button>
      </Flex>
    </Box>
  );
}
